// A utility function as a better replacement for setTimeOut:
// keeps checking on a boolean condition passed as a 2nd arg
// and then only runs a func after the condition is found to be true
const RunAsSoonAs = (func, condition) => {
    const interval = setInterval(() => {
        const conditionResult = condition();
        if (typeof condition === 'function' &&
            typeof conditionResult === 'boolean' &&
            conditionResult) {
            func();
            clearInterval(interval);
        }
    }, 0);
};
export default RunAsSoonAs;
